import { useIsTopLevelFeaturePage } from '@ms/yammer-hooks/dist/navigation';

type UseShouldHaveHeroBanner = () => boolean;
export const useShouldHaveHeroBanner: UseShouldHaveHeroBanner = () => {
  const isTopLevelFeaturePage = useIsTopLevelFeaturePage();

  return isTopLevelFeaturePage;
};
